/**
 * Business contact model.
 */
export class BusinessContact {
  /**
   * Unique identifier for this record in the database
   */
  id: number;

  /**
   * Source ID that identifies the source of this data (e.g., airport manager)
   */
  sourceId: number;

  /**
   * Contact name
   */
  contactName: string;

  /**
   * Contact title or department (e.g., "Manager")
   */
  titleDept: string;

  /**
   * Contact phone
   */
  phone: string;

  /**
   * Contact phone type (e.g., "Office")
   */
  phoneType: string;

  /**
   * Contact email address
   */
  email: string;

  /**
   * Ok to Publish
   */
  okToPublish: boolean;

  /**
   * Date record was last updated
   */
  updateDate: Date;

  /**
   * User ID who last updated the record
   */
  updateBy: Date;

  /**
   * Parses contact
   * @param data {any} Contact data as returned by API
   * @return {BusinessContact} Parsed contact
   */
  static parse(data: any): BusinessContact {
    return {
      id: data.contactId,
      sourceId: data.sourceId,
      contactName: data.contactName,
      titleDept: data.titleDept,
      phone: data.phone,
      phoneType: data.phoneType,
      email: data.email,
      updateDate: data.updateDate ? new Date(data.updateDate) : null,
      updateBy: data.updateBy,
      okToPublish: data.okToPublish || false
    };
  }
}
